export default __webpack_public_path__ + "static/media/art-0-pergola1.cc0e148c.jpeg";